<script lang="ts">
import type { Snippet } from 'svelte';
import type { Readable } from 'svelte/store';

import { Banner, BannerVariant, type BannerVariantType } from '../banner';

interface Props {
  title: string;
  message?: string;
  variant: BannerVariantType;
  progress: Readable<number>;
  dismiss: () => unknown;
  content?: Snippet;
}

const {
  title,
  message = '',
  variant,
  progress,
  dismiss,
  content,
}: Props = $props();
</script>

<Banner
  exitable
  class="pointer-events-auto relative z-9999 mb-2 w-screen sm:w-max sm:max-w-[600px] sm:min-w-[360px]"
  loading={variant === BannerVariant.Pending}
  on:close={dismiss}
  progress={$progress}
  {variant}
>
  {#snippet titleContent()}
    {title}
  {/snippet}
  {#snippet subtitle()}
    {#if message?.length}
      <span class="line-clamp-10 max-w-[300px] break-words overflow-ellipsis">
        {message}
      </span>
    {/if}
    {#if content}
      {@render content()}
    {/if}
  {/snippet}
</Banner>
